import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { Entity } from '../../../core/models/entity.model';
import type { UserSettings } from '../../../core/models/user-settings.model';

export const UserSettingsEntityActions = createActionGroup({
  source: 'User settings entity',
  events: {
    get_entity_start: emptyProps(),
    get_entity_success: props<{ entity: Entity }>(),
    get_entity_fail: props<{ error: any }>(),
    update_entity_start: props<{ settings: UserSettings }>(),
    update_entity_success: props<{ entity: Entity }>()
  }
});
